(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("lodash/assign"), require("lodash/isEqual"), require("react-motion"), require("react-portal"), require("@opuscapita/react-autocompletes"), require("moment"), require("react-day-picker/lib/src/DayPicker"), require("react-day-picker/lib/style.css"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "lodash/assign", "lodash/isEqual", "react-motion", "react-portal", "@opuscapita/react-autocompletes", "moment", "react-day-picker/lib/src/DayPicker", "react-day-picker/lib/style.css"], factory);
	else if(typeof exports === 'object')
		exports["MarkdownInput"] = factory(require("prop-types"), require("react"), require("lodash/assign"), require("lodash/isEqual"), require("react-motion"), require("react-portal"), require("@opuscapita/react-autocompletes"), require("moment"), require("react-day-picker/lib/src/DayPicker"), require("react-day-picker/lib/style.css"));
	else
		root["MarkdownInput"] = factory(root["prop-types"], root["React"], root["lodash/assign"], root["lodash/isEqual"], root["react-motion"], root["react-portal"], root["@opuscapita/react-autocompletes"], root["moment"], root["react-day-picker/lib/src/DayPicker"], root["react-day-picker/lib/style.css"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_28__, __WEBPACK_EXTERNAL_MODULE_40__, __WEBPACK_EXTERNAL_MODULE_41__, __WEBPACK_EXTERNAL_MODULE_42__, __WEBPACK_EXTERNAL_MODULE_151__, __WEBPACK_EXTERNAL_MODULE_152__, __WEBPACK_EXTERNAL_MODULE_153__, __WEBPACK_EXTERNAL_MODULE_154__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 155);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(58)('wks');
var uid = __webpack_require__(39);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(8);
var hide = __webpack_require__(9);
var redefine = __webpack_require__(15);
var ctx = __webpack_require__(18);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(20);
var defined = __webpack_require__(4);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(23);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var createDesc = __webpack_require__(57);
module.exports = __webpack_require__(19) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var hide = __webpack_require__(9);
var has = __webpack_require__(21);
var SRC = __webpack_require__(39)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(8).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(78).default;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(17);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(20)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(0)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(9)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(9);
var redefine = __webpack_require__(15);
var fails = __webpack_require__(20);
var defined = __webpack_require__(4);
var wks = __webpack_require__(0);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(82);
var toPrimitive = __webpack_require__(103);
var dP = Object.defineProperty;

exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(84);
var defined = __webpack_require__(4);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = require("lodash/assign");

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(75).default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMessage;
var translations = {
  en: {
    selectDateRange: 'Select date range',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    previousWeek: 'Previous week',
    nextWeek: 'Next week',
    thisWeek: 'This week',
    previousMonth: 'Previous month',
    last30Days: 'Last 30 days',
    thisMonth: 'This month',
    nextMonth: 'Next month'
  },
  de: {
    selectDateRange: 'Datumsbereich auswählen',
    today: 'Heute',
    yesterday: 'Gestern',
    tomorrow: 'Morgen',
    previousWeek: 'Vorherige Woche',
    nextWeek: 'Nächste Woche',
    thisWeek: 'Diese Woche',
    previousMonth: 'Vorheriger Monat',
    last30Days: 'Letzte 30 Tagen',
    thisMonth: 'Dieser Monat',
    nextMonth: 'Nächster Monat'
  },
  ru: {
    selectDateRange: 'Выберите диапазон дат',
    today: 'Сегодня',
    yesterday: 'Вчера',
    tomorrow: 'Завтра',
    previousWeek: 'Предыдущая неделя',
    nextWeek: 'Следующая неделя',
    thisWeek: 'Эта неделя',
    previousMonth: 'Предыдущий месяц',
    last30Days: 'Последние 30 дней',
    thisMonth: 'Этот месяц',
    nextMonth: 'Следующий месяц'
  },
  fi: {
    selectDateRange: 'Valitse päivämääräväli',
    today: 'Tänään',
    yesterday: 'Eilen',
    tomorrow: 'Huomenna',
    previousWeek: 'Edellinen viikko',
    nextWeek: 'Seuraava viikko',
    thisWeek: 'Tämä viikko',
    previousMonth: 'Edellinen kuukausi',
    last30Days: 'Edelliset 30 päivää',
    thisMonth: 'Tämä kuukausi',
    nextMonth: 'Seuraava kuukausi'
  },
  no: {
    selectDateRange: 'Velg datoområde',
    today: 'I dag',
    yesterday: 'I går',
    tomorrow: 'I morgen',
    previousWeek: 'Forrige uke',
    nextWeek: 'Neste uke',
    thisWeek: 'Denne uken',
    previousMonth: 'Foregående måned',
    last30Days: 'Siste 30 dager',
    thisMonth: 'Denne måneden',
    nextMonth: 'Neste måned'
  },
  sv: {
    selectDateRange: 'Välj datumintervall',
    today: 'Idag',
    yesterday: 'Igår',
    tomorrow: 'Imorgon',
    previousWeek: 'Föregående vecka',
    nextWeek: 'Nästa vecka',
    thisWeek: 'Denna vecka',
    previousMonth: 'Föregående månad',
    last30Days: 'SSenaste 30 dagarna',
    thisMonth: 'Denna månad',
    nextMonth: 'Nästa månad'
  }
};

function getMessage(locale, key) {
  var translationExists = translations[locale] && translations[locale][key];

  if (!translationExists) {
    return translations['en'][key];
  }

  return translations[locale][key];
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var overlayOffsetV = 4;

var getCoords = exports.getCoords = function getCoords(elem, showToTop, showToLeft) {
  if (!elem) {
    return { top: 0, left: 0 };
  }

  var rect = elem.getBoundingClientRect();

  return {
    top: showToTop ? rect.top - overlayOffsetV + window.pageYOffset : rect.top + rect.height + overlayOffsetV + window.pageYOffset,

    left: showToLeft ? rect.left + rect.width + document.body.scrollLeft : rect.left + document.body.scrollLeft,

    alwaysLeft: rect.left + rect.width + document.body.scrollLeft
  };
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(14);
var TAG = __webpack_require__(0)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(0)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(26).f;
var has = __webpack_require__(21);
var TAG = __webpack_require__(0)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(58)('keys');
var uid = __webpack_require__(39);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(52);
var defined = __webpack_require__(4);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(4);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = require("lodash/isEqual");

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = require("react-motion");

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = require("react-portal");

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(69).default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(74).default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(77).default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(27);
var toLength = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(61);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(80);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(51);
var isObject = __webpack_require__(5);
var toLength = __webpack_require__(6);
var ctx = __webpack_require__(18);
var IS_CONCAT_SPREADABLE = __webpack_require__(0)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(14);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(5);
var cof = __webpack_require__(14);
var MATCH = __webpack_require__(0)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(54);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(15);
var hide = __webpack_require__(9);
var has = __webpack_require__(21);
var Iterators = __webpack_require__(22);
var $iterCreate = __webpack_require__(87);
var setToStringTag = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(93);
var ITERATOR = __webpack_require__(0)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(17);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(94);
var enumBugKeys = __webpack_require__(48);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(23);
var defined = __webpack_require__(4);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(18);
var invoke = __webpack_require__(83);
var html = __webpack_require__(50);
var cel = __webpack_require__(33);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(14)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(23);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(59)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(53)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Here should be es2016 or CommonJS exports.

module.exports = {
  DateInput: __webpack_require__(68).default,
  DateRangeInput: __webpack_require__(73).default,
  DatePicker: __webpack_require__(71).default
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
__webpack_require__(62);
__webpack_require__(136);
__webpack_require__(107);
module.exports = __webpack_require__(8).Promise;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(121);
__webpack_require__(125);
__webpack_require__(132);
__webpack_require__(62);
__webpack_require__(116);
__webpack_require__(117);
__webpack_require__(122);
__webpack_require__(126);
__webpack_require__(128);
__webpack_require__(112);
__webpack_require__(113);
__webpack_require__(114);
__webpack_require__(115);
__webpack_require__(118);
__webpack_require__(119);
__webpack_require__(120);
__webpack_require__(123);
__webpack_require__(124);
__webpack_require__(127);
__webpack_require__(129);
__webpack_require__(130);
__webpack_require__(131);
__webpack_require__(108);
__webpack_require__(109);
__webpack_require__(110);
__webpack_require__(111);
module.exports = __webpack_require__(8).String;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
__webpack_require__(133);
__webpack_require__(134);
module.exports = __webpack_require__(8).Array;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(144);

var _DateInputField = __webpack_require__(43);

var _DateInputField2 = _interopRequireDefault(_DateInputField);

var _DayPicker = __webpack_require__(29);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _DateVariants = __webpack_require__(44);

var _DateVariants2 = _interopRequireDefault(_DateVariants);

var _InputAddonButton = __webpack_require__(45);

var _InputAddonButton2 = _interopRequireDefault(_InputAddonButton);

var _reactMotion = __webpack_require__(41);

var _assign3 = __webpack_require__(28);

var _assign4 = _interopRequireDefault(_assign3);

var _moment = __webpack_require__(16);

var _moment2 = _interopRequireDefault(_moment);

var _translations = __webpack_require__(30);

var _translations2 = _interopRequireDefault(_translations);

var _isEqual = __webpack_require__(40);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _reactPortal = __webpack_require__(42);

var _getCoords2 = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var springPreset = _reactMotion.presets.gentle;
var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
}; // eslint-disable-line no-param-reassign

function splitProps(props) {
  var specificPropNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var result = Object.keys(props).reduce(function (result, propName) {
    var isPropSpecific = specificPropNames.indexOf(propName) >= 0;
    if (isPropSpecific) {
      var _commonProps = (0, _assign4.default)({}, result[0]);
      var _specificProps = (0, _assign4.default)({}, result[1], _defineProperty({}, propName, props[propName]));
      return [_commonProps, _specificProps];
    }

    var commonProps = (0, _assign4.default)({}, result[0], _defineProperty({}, propName, props[propName]));
    var specificProps = (0, _assign4.default)({}, result[1]);
    return [commonProps, specificProps];
  }, [{}, {}]);

  return result;
}

var propTypes = {
  className: _propTypes2.default.string,
  dateFormat: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  showToLeft: _propTypes2.default.bool,
  showToTop: _propTypes2.default.bool,
  showVariants: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  value: _propTypes2.default.object,
  variants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    getLabel: _propTypes2.default.func,
    getValue: _propTypes2.default.func
  }))
};

var defaultProps = {
  className: '',
  dateFormat: 'dd/MM/yyyy',
  disabled: false,
  isValid: true,
  locale: 'en',
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onChange: function onChange() {},
  showToLeft: false,
  showToTop: false,
  tabIndex: 0,
  value: null,
  variants: [{
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'yesterday');
    },
    getValue: function getValue(locale) {
      return (0, _moment2.default)().locale(locale).subtract(1, 'days').toDate();
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'today');
    },
    getValue: function getValue(locale) {
      return (0, _moment2.default)().locale(locale).toDate();
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'tomorrow');
    },
    getValue: function getValue(locale) {
      return (0, _moment2.default)().locale(locale).add(1, 'days').toDate();
    }
  }]
};

var DateInput = function (_Component) {
  _inherits(DateInput, _Component);

  function DateInput(props) {
    _classCallCheck(this, DateInput);

    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));

    _this.handleDayClick = function (day) {
      _this.setState({ showPicker: false });
      _this.handleDateChange(day);
    };

    _this.handleBodyClick = function (event) {
      var clickedOutside = !_this.container.contains(event.target) && !_this.pickerContainer.contains(event.target);

      if (_this.variantsContainer) {
        clickedOutside = clickedOutside && !_this.variantsContainer.contains(event.target);
      }

      if (clickedOutside) {
        _this.hideVariants();
        _this.hidePicker();
      }
    };

    _this.handleBodyKeyDown = function (event) {
      if (event.which === 9) {
        _this.hideVariants();
        _this.hidePicker();
      }
      if (event.which === 27) {
        // ESC key
        _this.hideVariants();
        _this.hidePicker();
      }
    };

    _this.handleVariantsButtonClick = function () {
      var _ret2;

      if (_this.state.showVariants) {
        var _ret;

        return _ret = _this.hideVariants(), _possibleConstructorReturn(_this, _ret);
      }
      return _ret2 = _this.showVariants(), _possibleConstructorReturn(_this, _ret2);
    };

    _this.handleVariantSelect = function (value) {
      _this.hideVariants();
      _this.handleDateChange(value);
    };

    _this.handleError = function (error) {
      _this.setState({ error: error });
    };

    _this.handleDateChange = function (value) {
      _this.props.onChange(value);
      _this.setState({ error: null });
    };

    _this.handleInputFocus = function (event) {
      _this.props.onFocus(event);
      _this.showPicker();
    };

    _this.handleInputClick = function () {
      if (!_this.props.disabled) {
        _this.showPicker();
      }
    };

    _this.handleReset = function () {
      _this.setState({ error: null });
      _this.dateInputField.clear();
      _this.hidePicker();
      _this.props.onChange(null);
    };

    _this.handleBlur = function (e) {
      if (_this.state.error) {
        _this.handleReset();
      }
      _this.props.onBlur(e);
    };

    _this.state = {
      error: null,
      showPicker: false,
      showVariants: false
    };
    return _this;
  }

  _createClass(DateInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBodyClick);
      document.body.addEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var month = nextProps.value || new Date();
        if (this.reactDayPicker) {
          this.reactDayPicker.showMonth(month);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.error !== nextState.error || this.state.showPicker !== nextState.showPicker || this.state.showVariants !== nextState.showVariants || this.props.className !== nextProps.className || this.props.dateFormat !== nextProps.dateFormat || this.props.disabled !== nextProps.disabled || this.props.isValid !== nextProps.isValid || this.props.locale !== nextProps.locale || this.props.showToLeft !== nextProps.showToLeft || this.props.showToTop !== nextProps.showToTop || this.props.tabIndex !== nextProps.tabIndex || !(0, _isEqual2.default)(this.props.value, nextProps.value) || !(0, _isEqual2.default)(this.props.variants, nextProps.variants);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBodyClick);
      document.body.removeEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'showVariants',
    value: function showVariants() {
      this.setState({ showVariants: true, showPicker: false });
    }
  }, {
    key: 'hideVariants',
    value: function hideVariants() {
      this.setState({ showVariants: false });
    }
  }, {
    key: 'showPicker',
    value: function showPicker() {
      var month = this.props.value || new Date();
      this.reactDayPicker.showMonth(month);
      this.hideVariants();
      this.setState({ showPicker: true });
    }
  }, {
    key: 'hidePicker',
    value: function hidePicker() {
      this.setState({ showPicker: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          dateFormat = _props.dateFormat,
          disabled = _props.disabled,
          isValid = _props.isValid,
          locale = _props.locale,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onFocus = _props.onFocus,
          showToLeft = _props.showToLeft,
          showToTop = _props.showToTop,
          tabIndex = _props.tabIndex,
          value = _props.value,
          variants = _props.variants,
          restProps = _objectWithoutProperties(_props, ['className', 'dateFormat', 'disabled', 'isValid', 'locale', 'onBlur', 'onChange', 'onFocus', 'showToLeft', 'showToTop', 'tabIndex', 'value', 'variants']);

      var _state = this.state,
          error = _state.error,
          showPicker = _state.showPicker,
          showVariants = _state.showVariants;


      var momentCompatibleDateFormat = dateFormat.replace(/d/g, 'D').replace(/y/g, 'Y');

      var splittedProps = splitProps(restProps, Object.keys(_DayPicker2.default.propTypes));
      var dayPickerSpecificProps = splittedProps[1];

      var pickerElement = _react2.default.createElement(_DayPicker2.default, _extends({
        dayPickerRef: function dayPickerRef(el) {
          return _this2.reactDayPicker = el;
        },
        locale: locale,
        month: value,
        selectedDays: value,
        tabIndex: -1,
        fixedWeeks: true,
        onChange: this.handleDateChange,
        onDayClick: this.handleDayClick
      }, dayPickerSpecificProps));

      var hasErrorClassName = error === null && isValid ? '' : 'has-error';

      var _getCoords = (0, _getCoords2.getCoords)(this.container, showToTop, showToLeft),
          top = _getCoords.top,
          left = _getCoords.left,
          alwaysLeft = _getCoords.alwaysLeft;

      var pickerMotionElement = _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showPicker ? 1 : 0 },
          style: { x: showPicker ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            _reactPortal.Portal,
            { isOpened: true },
            _react2.default.createElement(
              'div',
              {
                ref: function ref(_ref) {
                  return _this2.pickerContainer = _ref;
                },
                className: 'opuscapita_date-input__picker-container',
                style: {
                  maxHeight: interpolatedStyle.x * 640 + 'px',
                  opacity: easeOutCubic(interpolatedStyle.x),
                  top: top + 'px',
                  left: left + 'px',
                  transform: 'translate(' + (showToLeft ? '-100%' : '0') + ', ' + (showToTop ? '-100%' : '0') + ')'
                }
              },
              pickerElement
            )
          );
        }
      );

      var resetButton = _react2.default.createElement(
        _InputAddonButton2.default,
        {
          className: 'opuscapita_date-input__reset-btn',
          tabIndex: '-1',
          onClick: this.handleReset,
          disabled: disabled
        },
        '\u2715'
      );

      var variantsElement = null;

      if (typeof variants !== 'undefined' && variants.length) {
        var translatedVariants = variants.map(function (variant) {
          return _extends({}, variant, {
            label: variant.getLabel(locale)
          });
        });

        variantsElement = _react2.default.createElement(_DateVariants2.default, {
          onChange: this.handleVariantSelect,
          locale: locale,
          variants: translatedVariants
        });
      }

      var variantsMotionElement = variantsElement ? _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showVariants ? 1 : 0 },
          style: { x: showVariants ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            _reactPortal.Portal,
            { isOpened: true },
            _react2.default.createElement(
              'div',
              {
                ref: function ref(_ref2) {
                  return _this2.variantsContainer = _ref2;
                },
                className: 'opuscapita_date-input__variants-container',
                style: {
                  maxHeight: interpolatedStyle.x * 640 + 'px',
                  opacity: easeOutCubic(interpolatedStyle.x),
                  top: top + 'px',
                  left: alwaysLeft + 'px',
                  transform: 'translate(-100%, ' + (showToTop ? '-100%' : '0') + ')'
                }
              },
              variantsElement
            )
          );
        }
      ) : null;

      var variantsButton = typeof variants !== 'undefined' && variants.length ? _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-default opuscapita_date-input__variants-btn',
          disabled: disabled,
          tabIndex: '-1',
          onClick: this.handleVariantsButtonClick
        },
        _react2.default.createElement('span', { className: 'caret' })
      ) : null;

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(el) {
            return _this2.container = el;
          },
          className: 'opuscapita_date-input form-control ' + hasErrorClassName + ' ' + className
        },
        _react2.default.createElement(
          'div',
          { className: 'opuscapita_date-input__input-container' },
          _react2.default.createElement(_DateInputField2.default, {
            dateFormat: momentCompatibleDateFormat,
            disabled: disabled,
            onBlur: this.handleBlur,
            onChange: this.handleDateChange,
            onClick: this.handleInputClick,
            onError: this.handleError,
            onFocus: this.handleInputFocus,
            onRef: function onRef(dateInputField) {
              return _this2.dateInputField = dateInputField;
            },
            tabIndex: tabIndex,
            value: value
          }),
          resetButton
        ),
        pickerMotionElement,
        variantsMotionElement,
        variantsButton
      );
    }
  }]);

  return DateInput;
}(_react.Component);

exports.default = DateInput;


DateInput.propTypes = propTypes;
DateInput.defaultProps = defaultProps;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(67).default;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(16);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _propTypes2.default.string,
  dateFormat: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onRef: _propTypes2.default.func,
  value: _propTypes2.default.object
};

var defaultProps = {
  className: '',
  dateFormat: 'dd/MM/yyyy',
  disabled: false,
  locale: 'en',
  onChange: function onChange() {},
  onError: function onError() {},
  onRef: function onRef() {},
  value: null
};

var DateInputField = function (_Component) {
  _inherits(DateInputField, _Component);

  function DateInputField(props) {
    _classCallCheck(this, DateInputField);

    var _this = _possibleConstructorReturn(this, (DateInputField.__proto__ || Object.getPrototypeOf(DateInputField)).call(this, props));

    _this.clear = function () {
      _this.setState({ inputValue: '' });
    };

    _this.handleInputChange = function (event) {
      var inputValue = event.target.value;
      _this.validate(inputValue, _this.props.dateFormat);
      _this.setState({ inputValue: inputValue });
    };

    _this.handleRef = function () {
      _this.props.onRef(_this);
    };

    _this.state = {
      inputValue: props.value ? (0, _moment2.default)(props.value.toISOString()).format(props.dateFormat) : ''
    };
    return _this;
  }

  _createClass(DateInputField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value || this.props.dateFormat !== nextProps.dateFormat) {
        var inputValue = nextProps.value ? (0, _moment2.default)(nextProps.value.toISOString()).format(nextProps.dateFormat) : '';
        this.setState({ inputValue: inputValue });
      }
    }
  }, {
    key: 'validate',
    value: function validate(dateString, dateFormat) {
      var momentDate = (0, _moment2.default)(dateString, dateFormat, true);
      var error = momentDate.isValid() ? null : momentDate.invalidAt();

      if (error !== null && dateString.length) {
        this.props.onError(error);
      } else {
        var value = !dateString.length ? null : momentDate.toDate();
        this.props.onChange(value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          dateFormat = _props.dateFormat,
          disabled = _props.disabled,
          locale = _props.locale,
          onChange = _props.onChange,
          onError = _props.onError,
          onRef = _props.onRef,
          value = _props.value,
          restProps = _objectWithoutProperties(_props, ['className', 'dateFormat', 'disabled', 'locale', 'onChange', 'onError', 'onRef', 'value']);

      var inputValue = this.state.inputValue;


      return _react2.default.createElement(
        'div',
        {
          ref: this.handleRef,
          className: 'opuscapita_date-input-field form-control ' + className,
          disabled: disabled
        },
        _react2.default.createElement('input', _extends({
          ref: function ref(_ref) {
            _this2.dateInputFieldRef = _ref;
          },
          type: 'text',
          className: 'opuscapita_date-input-field__input',
          value: inputValue,
          placeholder: dateFormat,
          disabled: disabled,
          onChange: this.handleInputChange
        }, restProps))
      );
    }
  }]);

  return DateInputField;
}(_react.Component);

exports.default = DateInputField;


DateInputField.propTypes = propTypes;
DateInputField.defaultProps = defaultProps;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(146);

var _DayPicker = __webpack_require__(29);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _reactMotion = __webpack_require__(41);

var _assign3 = __webpack_require__(28);

var _assign4 = _interopRequireDefault(_assign3);

var _isEqual = __webpack_require__(40);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _reactPortal = __webpack_require__(42);

var _getCoords2 = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var springPreset = _reactMotion.presets.gentle;
var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
}; // eslint-disable-line no-param-reassign

function splitProps(props) {
  var specificPropNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var result = Object.keys(props).reduce(function (result, propName) {
    var isPropSpecific = specificPropNames.indexOf(propName) >= 0;
    if (isPropSpecific) {
      var _commonProps = (0, _assign4.default)({}, result[0]);
      var _specificProps = (0, _assign4.default)({}, result[1], _defineProperty({}, propName, props[propName]));
      return [_commonProps, _specificProps];
    }

    var commonProps = (0, _assign4.default)({}, result[0], _defineProperty({}, propName, props[propName]));
    var specificProps = (0, _assign4.default)({}, result[1]);
    return [commonProps, specificProps];
  }, [{}, {}]);

  return result;
}

var propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  showToLeft: _propTypes2.default.bool,
  showToTop: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  value: _propTypes2.default.object
};

var defaultProps = {
  className: '',
  disabled: false,
  locale: 'en',
  onChange: function onChange() {},
  showToLeft: false,
  showToTop: false,
  tabIndex: 0,
  value: null
};

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _this.handlePortalClose = function (event) {
      _this.hidePicker();
    };

    _this.handleDayClick = function (day) {
      _this.handleDateChange(day);
      _this.setState({ showPicker: false });
    };

    _this.handleToggleClick = function () {
      if (_this.state.showPicker) {
        _this.hidePicker();
      } else {
        _this.showPicker();
      }
    };

    _this.handleDateChange = function (value) {
      _this.props.onChange(value);
    };

    _this.handleBodyClick = function (event) {
      var clickedOutside = !_this.container.contains(event.target) && !_this.datePickerRef.contains(event.target);

      if (clickedOutside) {
        _this.hidePicker();
      }
    };

    _this.handleBodyKeyDown = function (event) {
      if (event.which === 9) {
        _this.hidePicker();
      }
      if (event.which === 27) {
        // ESC key
        _this.hidePicker();
      }
    };

    _this.state = {
      showPicker: false
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBodyClick);
      document.body.addEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.showPicker !== nextState.showPicker || this.props.className !== nextProps.className || this.props.disabled !== nextProps.disabled || this.props.locale !== nextProps.locale || this.props.showToLeft !== nextProps.showToLeft || this.props.showToTop !== nextProps.showToTop || this.props.tabIndex !== nextProps.tabIndex || !(0, _isEqual2.default)(this.props.value, nextProps.value);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBodyClick);
      document.body.removeEventListener('keydown', this.handlePortalClose);
    }
  }, {
    key: 'showPicker',
    value: function showPicker() {
      this.setState({ showPicker: true });
    }
  }, {
    key: 'hidePicker',
    value: function hidePicker() {
      this.setState({ showPicker: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          locale = _props.locale,
          onChange = _props.onChange,
          showToLeft = _props.showToLeft,
          showToTop = _props.showToTop,
          tabIndex = _props.tabIndex,
          value = _props.value,
          restProps = _objectWithoutProperties(_props, ['className', 'disabled', 'locale', 'onChange', 'showToLeft', 'showToTop', 'tabIndex', 'value']);

      var showPicker = this.state.showPicker;


      var splittedProps = splitProps(restProps, Object.keys(_DayPicker2.default.propTypes));
      var commonProps = splittedProps[0];
      var dayPickerSpecificProps = splittedProps[1];

      var pickerElement = _react2.default.createElement(_DayPicker2.default, _extends({
        dayPickerRef: function dayPickerRef(el) {
          return _this2.reactDayPicker = el;
        },
        locale: locale,
        month: value,
        selectedDays: value,
        tabIndex: -1,
        fixedWeeks: true,
        onDayClick: this.handleDayClick,
        onChange: this.handleDateChange
      }, dayPickerSpecificProps));

      var _getCoords = (0, _getCoords2.getCoords)(this.container, showToTop, showToLeft),
          top = _getCoords.top,
          left = _getCoords.left;

      var pickerMotionElement = _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showPicker ? 1 : 0 },
          style: { x: showPicker ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            _reactPortal.Portal,
            {
              isOpened: true,
              onClose: _this2.handlePortalClose
            },
            _react2.default.createElement(
              'div',
              {
                ref: function ref(_ref) {
                  _this2.datePickerRef = _ref;
                },
                className: 'opuscapita_date-picker__picker-container',
                style: {
                  maxHeight: interpolatedStyle.x * 640 + 'px',
                  opacity: easeOutCubic(interpolatedStyle.x),
                  top: top + 'px',
                  left: left + 'px',
                  transform: 'translate(' + (showToLeft ? '-100%' : '0') + ', ' + (showToTop ? '-100%' : '0') + ')'
                }
              },
              pickerElement
            )
          );
        }
      );

      return _react2.default.createElement(
        'div',
        _extends({
          className: 'opuscapita_date-picker ' + className,
          ref: function ref(el) {
            return _this2.container = el;
          }
        }, commonProps),
        _react2.default.createElement(
          'button',
          {
            className: 'opuscapita_date-picker__toggle-picker btn btn-default',
            disabled: disabled,
            onClick: this.handleToggleClick,
            tabIndex: tabIndex,
            type: 'button'
          },
          _react2.default.createElement('i', { className: 'fa fa-calendar' })
        ),
        pickerMotionElement
      );
    }
  }]);

  return DatePicker;
}(_react.Component);

exports.default = DatePicker;


DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(70).default;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(147);

var _DayPicker = __webpack_require__(29);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _InputAddonButton = __webpack_require__(45);

var _InputAddonButton2 = _interopRequireDefault(_InputAddonButton);

var _DateVariants = __webpack_require__(44);

var _DateVariants2 = _interopRequireDefault(_DateVariants);

var _DateInputField = __webpack_require__(43);

var _DateInputField2 = _interopRequireDefault(_DateInputField);

var _assign3 = __webpack_require__(28);

var _assign4 = _interopRequireDefault(_assign3);

var _isEqual = __webpack_require__(40);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _moment = __webpack_require__(16);

var _moment2 = _interopRequireDefault(_moment);

var _reactMotion = __webpack_require__(41);

var _translations = __webpack_require__(30);

var _translations2 = _interopRequireDefault(_translations);

var _reactPortal = __webpack_require__(42);

var _getCoords2 = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var springPreset = _reactMotion.presets.gentle;
var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
}; // eslint-disable-line no-param-reassign

function splitProps(props) {
  var specificPropNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var result = Object.keys(props).reduce(function (result, propName) {
    var isPropSpecific = specificPropNames.indexOf(propName) >= 0;
    if (isPropSpecific) {
      var _commonProps = (0, _assign4.default)({}, result[0]);
      var _specificProps = (0, _assign4.default)({}, result[1], _defineProperty({}, propName, props[propName]));
      return [_commonProps, _specificProps];
    }

    var commonProps = (0, _assign4.default)({}, result[0], _defineProperty({}, propName, props[propName]));
    var specificProps = (0, _assign4.default)({}, result[1]);
    return [commonProps, specificProps];
  }, [{}, {}]);

  return result;
}

var initialState = {
  enteredTo: null,
  showPicker: false,
  showVariants: false,
  error: false,
  focused: false
};

function isSelectingFirstDay(from, to, day) {
  var firstDayIsNotSelected = !from;
  var selectedDayIsBeforeFirstDay = day < from;
  var rangeIsSelected = from && to;
  return firstDayIsNotSelected || selectedDayIsBeforeFirstDay || rangeIsSelected;
}

var propTypes = {
  className: _propTypes2.default.string,
  dateFormat: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  showToLeft: _propTypes2.default.bool,
  showToTop: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  value: _propTypes2.default.array,
  variants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    getLabel: _propTypes2.default.func,
    getValue: _propTypes2.default.func
  }))
};

var defaultProps = {
  className: '',
  dateFormat: 'dd/MM/yyyy',
  disabled: false,
  isValid: true,
  locale: 'en',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  showToLeft: false,
  showToTop: false,
  tabIndex: 0,
  value: [null, null],
  variants: [{
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'previousWeek');
    },
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).subtract(7, 'days').startOf('week').toDate(), (0, _moment2.default)().locale(locale).subtract(7, 'days').endOf('week').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'thisWeek');
    },
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).startOf('week').toDate(), (0, _moment2.default)().locale(locale).endOf('week').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'nextWeek');
    },
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).add(7, 'days').startOf('week').toDate(), (0, _moment2.default)().locale(locale).add(7, 'days').endOf('week').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'previousMonth');
    },
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).subtract(1, 'month').startOf('month').toDate(), (0, _moment2.default)().locale(locale).subtract(1, 'month').endOf('month').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'last30Days');
    },
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).subtract(30, 'days').toDate(), (0, _moment2.default)().locale(locale).toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'thisMonth');
    },
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).startOf('month').toDate(), (0, _moment2.default)().locale(locale).endOf('month').toDate()];
    }
  }, {
    getLabel: function getLabel(locale) {
      return (0, _translations2.default)(locale, 'nextMonth');
    },
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).add(1, 'month').startOf('month').toDate(), (0, _moment2.default)().locale(locale).add(1, 'month').endOf('month').toDate()];
    }
  }]
};

var DateRangeInput = function (_Component) {
  _inherits(DateRangeInput, _Component);

  function DateRangeInput(props) {
    _classCallCheck(this, DateRangeInput);

    var _this = _possibleConstructorReturn(this, (DateRangeInput.__proto__ || Object.getPrototypeOf(DateRangeInput)).call(this, props));

    _this.handleRangeChange = function (range) {
      _this.setState({ enteredTo: null, error: false });
      var normalizedRange = _this.normalizeRange(range);
      _this.props.onChange(normalizedRange);
    };

    _this.handleDayClick = function (day) {
      var from = _this.props.value[0];
      var to = _this.props.value[1];

      if (isSelectingFirstDay(from, to, day)) {
        _this.handleRangeChange([day, null]);
        _this.setState({
          enteredTo: null
        });
      } else {
        _this.handleRangeChange([from, day]);
        _this.setState({
          enteredTo: day,
          showPicker: false
        });
      }
    };

    _this.handleBodyClick = function (event) {
      var clickedOutside = !_this.container.contains(event.target) && !_this.pickerContainer.contains(event.target);

      if (_this.variantsContainer) {
        clickedOutside = clickedOutside && !_this.variantsContainer.contains(event.target);
      }

      if (clickedOutside) {
        _this.hideVariants();
        _this.hidePicker();
      }
    };

    _this.handleBodyKeyDown = function (event) {
      if (event.which === 9) {
        // TAB key
        _this.hideVariants();
        _this.hidePicker();
      }
      if (event.which === 27) {
        // ESC key
        _this.hidePicker();
        _this.hideVariants();
      }
    };

    _this.handleVariantsButtonClick = function () {
      var _ret2;

      if (_this.state.showVariants) {
        var _ret;

        return _ret = _this.hideVariants(), _possibleConstructorReturn(_this, _ret);
      }
      return _ret2 = _this.showVariants(), _possibleConstructorReturn(_this, _ret2);
    };

    _this.handleVariantSelect = function (range) {
      _this.hideVariants();
      _this.setState({ enteredTo: range[1] });
      _this.handleRangeChange(range);
    };

    _this.handleFocus = function (e, inputName) {
      _this.props.onFocus(e, inputName);
      _this.showPicker();

      _this.setState({ focused: true });
    };

    _this.handleBlur = function (e, inputName) {
      _this.props.onBlur(e, inputName);
      _this.hideVariants();

      _this.setState({ focused: false });
    };

    _this.handleError = function () {
      _this.setState({ error: true });
    };

    _this.handleInputClick = function () {
      if (!_this.props.disabled) {
        _this.showPicker();
      }
    };

    _this.handleDayMouseEnter = function (day) {
      var from = _this.props.value[0];
      var to = _this.props.value[1];

      if (!isSelectingFirstDay(from, to, day)) {
        _this.setState({
          enteredTo: day
        });
      }
    };

    _this.handleDayMouseLeave = function (day) {
      _this.setState({ enteredTo: null });
    };

    _this.handleReset = function () {
      _this.setState(initialState);
      _this.handleRangeChange([null, null]);
      _this.dateInputFieldTo.clear();
      _this.dateInputFieldFrom.clear();
    };

    _this.state = initialState;
    return _this;
  }

  _createClass(DateRangeInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBodyClick);
      document.body.addEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value[0] !== nextProps.value[0]) {
        var month = nextProps.value[0] || new Date();
        if (this.reactDayPicker) {
          this.reactDayPicker.showMonth(month);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _isEqual2.default)(this.state.enteredTo, nextState.enteredTo) || this.state.showPicker !== nextState.showPicker || this.state.showVariants !== nextState.showVariants || this.state.error !== nextState.error || this.state.focused !== nextState.focused || this.props.className !== nextProps.className || this.props.dateFormat !== nextProps.dateFormat || this.props.disabled !== nextProps.disabled || this.props.isValid !== nextProps.isValid || this.props.locale !== nextProps.locale || this.props.showToLeft !== nextProps.showToLeft || this.props.showToTop !== nextProps.showToTop || this.props.tabIndex !== nextProps.tabIndex || !(0, _isEqual2.default)(this.props.value, nextProps.value) || !(0, _isEqual2.default)(this.props.variants, nextProps.variants);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var rangeChanged = this.state.from !== nextState.from || this.state.to !== nextState.to;
      var rangeFilled = nextState.from !== null && nextState.to !== null;
      if (rangeChanged && rangeFilled) {
        this.handleRangeChange([nextState.from, nextState.to]);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBodyClick);
      document.body.removeEventListener('keydown', this.handleBodyKeyDown);
    }
  }, {
    key: 'normalizeRange',
    value: function normalizeRange(range) {
      var from = range[0];
      var to = range[1];
      var fromGreaterThanTo = from && to && from.getTime() > to.getTime();
      if (fromGreaterThanTo) {
        return [to, from];
      }
      return range;
    }
  }, {
    key: 'showPicker',
    value: function showPicker() {
      var month = this.props.value[0] || new Date();
      this.reactDayPicker.showMonth(month);
      this.setState({ showPicker: true, showVariants: false });
    }
  }, {
    key: 'hidePicker',
    value: function hidePicker() {
      this.setState({ showPicker: false });
    }
  }, {
    key: 'showVariants',
    value: function showVariants() {
      this.setState({ showVariants: true, showPicker: false });
    }
  }, {
    key: 'hideVariants',
    value: function hideVariants() {
      this.setState({ showVariants: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          dateFormat = _props.dateFormat,
          value = _props.value,
          disabled = _props.disabled,
          locale = _props.locale,
          isValid = _props.isValid,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onFocus = _props.onFocus,
          tabIndex = _props.tabIndex,
          showToTop = _props.showToTop,
          showToLeft = _props.showToLeft,
          variants = _props.variants,
          restProps = _objectWithoutProperties(_props, ['className', 'dateFormat', 'value', 'disabled', 'locale', 'isValid', 'onBlur', 'onChange', 'onFocus', 'tabIndex', 'showToTop', 'showToLeft', 'variants']);

      var splittedProps = splitProps(restProps, Object.keys(_DayPicker2.default.propTypes));
      var commonProps = splittedProps[0];
      var dayPickerSpecificProps = splittedProps[1];

      var from = this.props.value[0];
      var to = this.props.value[1];
      var _state = this.state,
          enteredTo = _state.enteredTo,
          error = _state.error,
          focused = _state.focused,
          showPicker = _state.showPicker,
          showVariants = _state.showVariants;

      var momentCompatibleDateFormat = dateFormat.replace(/d/g, 'D').replace(/y/g, 'Y');

      var pickerElement = _react2.default.createElement(_DayPicker2.default, _extends({
        className: 'Range',
        disabledDays: { before: from },
        fixedWeeks: true,
        month: from,
        hideTodayButton: true,
        locale: locale,
        modifiers: { start: from, end: enteredTo || to },
        numberOfMonths: 2,
        isRange: true,
        onChange: this.handleRangeChange,
        onDayClick: this.handleDayClick,
        onDayMouseEnter: this.handleDayMouseEnter,
        onDayMouseLeave: this.handleDayMouseLeave,
        selectedDays: [from, { from: from, to: enteredTo || to }],
        dayPickerRef: function dayPickerRef(el) {
          return _this2.reactDayPicker = el;
        }
      }, dayPickerSpecificProps));

      var variantsElement = null;

      if (typeof variants !== 'undefined' && variants.length) {
        var translatedVariants = variants.map(function (variant) {
          return _extends({}, variant, {
            label: variant.getLabel(locale)
          });
        });

        variantsElement = _react2.default.createElement(_DateVariants2.default, {
          onChange: this.handleVariantSelect,
          locale: locale,
          variants: translatedVariants
        });
      }

      var _getCoords = (0, _getCoords2.getCoords)(this.container, showToTop, showToLeft),
          top = _getCoords.top,
          left = _getCoords.left,
          alwaysLeft = _getCoords.alwaysLeft;

      var pickerMotionElement = _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showPicker ? 1 : 0 },
          style: { x: showPicker ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            _reactPortal.Portal,
            { isOpened: true },
            _react2.default.createElement(
              'div',
              {
                ref: function ref(_ref) {
                  return _this2.pickerContainer = _ref;
                },
                className: 'opuscapita_date-range-input__picker-container',
                style: {
                  maxHeight: interpolatedStyle.x * 640 + 'px',
                  opacity: easeOutCubic(interpolatedStyle.x),
                  top: top + 'px',
                  left: left + 'px',
                  transform: 'translate(' + (showToLeft ? '-100%' : '0') + ', ' + (showToTop ? '-100%' : '0') + ')'
                }
              },
              pickerElement
            )
          );
        }
      );

      var variantsMotionElement = variantsElement ? _react2.default.createElement(
        _reactMotion.Motion,
        {
          defaultStyle: { x: showVariants ? 1 : 0 },
          style: { x: showVariants ? (0, _reactMotion.spring)(1, springPreset) : (0, _reactMotion.spring)(0, springPreset) }
        },
        function (interpolatedStyle) {
          return _react2.default.createElement(
            _reactPortal.Portal,
            { isOpened: true },
            _react2.default.createElement(
              'div',
              {
                ref: function ref(_ref2) {
                  return _this2.variantsContainer = _ref2;
                },
                className: 'opuscapita_date-range-input__variants-container',
                style: {
                  maxHeight: interpolatedStyle.x * 640 + 'px',
                  opacity: easeOutCubic(interpolatedStyle.x),
                  top: top + 'px',
                  left: alwaysLeft + 'px',
                  transform: 'translate(-100%, ' + (showToTop ? '-100%' : '0') + ')'
                }
              },
              variantsElement
            )
          );
        }
      ) : null;

      var resetButton = _react2.default.createElement(
        _InputAddonButton2.default,
        {
          className: 'opuscapita_date-range-input__reset-btn',
          tabIndex: '-1',
          onClick: this.handleReset,
          disabled: disabled
        },
        '\u2715'
      );

      var variantsButton = typeof variants !== 'undefined' && variants.length ? _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-default opuscapita_date-range-input__variants-btn',
          disabled: disabled,
          tabIndex: '-1',
          onClick: this.handleVariantsButtonClick
        },
        _react2.default.createElement('span', { className: 'caret' })
      ) : null;

      var hasErrorClassName = isValid && !error ? '' : 'has-error';
      var focusedClassName = focused ? 'opuscapita_date-range-input__input-field-container--focused' : '';

      return _react2.default.createElement(
        'div',
        _extends({
          ref: function ref(el) {
            return _this2.container = el;
          },
          className: 'opuscapita_date-range-input form-control ' + className
        }, commonProps),
        _react2.default.createElement(
          'div',
          {
            className: '\n            opuscapita_date-range-input__input-field-container\n            form-control\n            ' + hasErrorClassName + '\n            ' + focusedClassName + '\n          '
          },
          _react2.default.createElement(_DateInputField2.default, {
            className: 'opuscapita_date-range-input__input-field opuscapita_date-range-input__left-input-field',
            dateFormat: momentCompatibleDateFormat,
            disabled: disabled,
            onBlur: function onBlur(e) {
              return _this2.handleBlur(e, 'from');
            },
            onFocus: function onFocus(e) {
              return _this2.handleFocus(e, 'from');
            },
            onChange: function onChange(date) {
              return _this2.handleRangeChange([date, value[1]]);
            },
            onClick: this.handleInputClick,
            onError: this.handleError,
            onRef: function onRef(dateInputField) {
              return _this2.dateInputFieldFrom = dateInputField;
            },
            tabIndex: tabIndex,
            value: value[0]
          }),
          _react2.default.createElement(
            'div',
            { className: 'opuscapita_date-range-input__dash' },
            '\u2015'
          ),
          _react2.default.createElement(_DateInputField2.default, {
            className: 'opuscapita_date-range-input__input-field opuscapita_date-range-input__right-input-field',
            dateFormat: momentCompatibleDateFormat,
            disabled: disabled,
            onBlur: function onBlur(e) {
              return _this2.handleBlur(e, 'to');
            },
            onFocus: function onFocus(e) {
              return _this2.handleFocus(e, 'to');
            },
            onChange: function onChange(date) {
              return _this2.handleRangeChange([value[0], date]);
            },
            onClick: this.handleInputClick,
            onError: this.handleError,
            onRef: function onRef(dateInputField) {
              return _this2.dateInputFieldTo = dateInputField;
            },
            tabIndex: tabIndex,
            value: value[1]
          }),
          resetButton
        ),
        pickerMotionElement,
        variantsMotionElement,
        variantsButton
      );
    }
  }]);

  return DateRangeInput;
}(_react.Component);

exports.default = DateRangeInput;


DateRangeInput.propTypes = propTypes;
DateRangeInput.defaultProps = defaultProps;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = __webpack_require__(72).default;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _reactAutocompletes = __webpack_require__(151);

var _moment = __webpack_require__(16);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  variants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.array
  })),
  onChange: _propTypes2.default.func,
  locale: _propTypes2.default.string
};

var defaultProps = {
  variants: [{
    label: 'Previous week',
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).subtract(7, 'days').startOf('week').toDate(), (0, _moment2.default)().locale(locale).subtract(7, 'days').endOf('week').toDate()];
    }
  }, {
    label: 'This week',
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).startOf('week').toDate(), (0, _moment2.default)().locale(locale).endOf('week').toDate()];
    }
  }, {
    label: 'Next week',
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).add(7, 'days').startOf('week').toDate(), (0, _moment2.default)().locale(locale).add(7, 'days').endOf('week').toDate()];
    }
  }, {
    label: 'Previous month',
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).subtract(1, 'month').startOf('month').toDate(), (0, _moment2.default)().locale(locale).subtract(1, 'month').endOf('month').toDate()];
    }
  }, {
    label: 'Last 30 days',
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).subtract(30, 'days').toDate(), (0, _moment2.default)().locale(locale).toDate()];
    }
  }, {
    label: 'This month',
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).startOf('month').toDate(), (0, _moment2.default)().locale(locale).endOf('month').toDate()];
    }
  }, {
    label: 'Next month',
    getValue: function getValue(locale) {
      return [(0, _moment2.default)().locale(locale).add(1, 'month').startOf('month').toDate(), (0, _moment2.default)().locale(locale).add(1, 'month').endOf('month').toDate()];
    }
  }],
  onChange: function onChange() {},
  locale: 'en'
};

var DateVariants = function (_Component) {
  _inherits(DateVariants, _Component);

  function DateVariants() {
    _classCallCheck(this, DateVariants);

    return _possibleConstructorReturn(this, (DateVariants.__proto__ || Object.getPrototypeOf(DateVariants)).apply(this, arguments));
  }

  _createClass(DateVariants, [{
    key: 'handleChange',
    value: function handleChange(key) {
      var variants = this.props.variants;
      var value = variants[key].getValue(this.props.locale);
      this.props.onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          variants = _props.variants,
          onChange = _props.onChange;

      var items = variants.map(function (variant, index) {
        return {
          key: index.toString(),
          value: variant.label
        };
      });

      var variantsElement = _react2.default.createElement(
        'li',
        { className: 'opuscapita_date-range-variants__list' },
        _react2.default.createElement(_reactAutocompletes.VerticalList, { onClick: function onClick(event, key) {
            return _this2.handleChange(key);
          }, items: items })
      );

      return _react2.default.createElement(
        'div',
        { className: 'opuscapita_date-range-variants' },
        variantsElement
      );
    }
  }]);

  return DateVariants;
}(_react.Component);

exports.default = DateVariants;


DateVariants.propTypes = propTypes;
DateVariants.defaultProps = defaultProps;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

var _DayPicker = __webpack_require__(153);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

__webpack_require__(154);

var _MomentLocaleUtils = __webpack_require__(76);

var _MomentLocaleUtils2 = _interopRequireDefault(_MomentLocaleUtils);

var _translations = __webpack_require__(30);

var _translations2 = _interopRequireDefault(_translations);

var _assign3 = __webpack_require__(28);

var _assign4 = _interopRequireDefault(_assign3);

__webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function splitProps(props) {
  var specificPropNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return Object.keys(props).reduce(function (result, propName) {
    var isPropSpecific = specificPropNames.indexOf(propName) >= 0;
    if (isPropSpecific) {
      var _commonProps = (0, _assign4.default)({}, result[0]);
      var _specificProps = (0, _assign4.default)({}, result[1], _defineProperty({}, propName, props[propName]));
      return [_commonProps, _specificProps];
    }

    var commonProps = (0, _assign4.default)({}, result[0], _defineProperty({}, propName, props[propName]));
    var specificProps = (0, _assign4.default)({}, result[1]);
    return [commonProps, specificProps];
  }, [{}, {}]);
}

function Caption(props) {
  var date = props.date,
      locale = props.locale,
      localeUtils = props.localeUtils,
      isRange = props.isRange,
      onChange = props.onChange,
      currentMonth = props.currentMonth;


  var months = localeUtils.getMonths(locale);
  var dateNow = new Date();
  var years = [];
  for (var i = dateNow.getFullYear() - 100; i <= dateNow.getFullYear() + 100; i += 1) {
    years.push(i);
  }

  var handleChange = function handleChange(year, month) {
    var newDate = new Date(year, month);
    if (isRange) {
      var isCaptionFrom = date.getMonth() === currentMonth.getMonth();
      var captionIndex = isCaptionFrom ? 0 : 1;
      onChange(newDate, captionIndex);
    } else {
      onChange(newDate);
    }
  };

  var handleYearChange = function handleYearChange(event) {
    handleChange(event.target.value, date.getMonth());
  };

  var handleMonthChange = function handleMonthChange(event) {
    handleChange(date.getFullYear(), event.target.value);
  };

  return _react2.default.createElement(
    'div',
    { className: 'DayPicker-Caption' },
    _react2.default.createElement(
      'div',
      { className: 'form-group opuscapita_day-picker__caption' },
      _react2.default.createElement(
        'select',
        {
          className: 'opuscapita_day-picker__caption-select',
          onChange: handleMonthChange,
          name: 'month',
          value: date.getMonth(),
          tabIndex: -1
        },
        months.map(function (month, index) {
          return _react2.default.createElement(
            'option',
            { key: index, value: index },
            month
          );
        })
      ),
      _react2.default.createElement(
        'select',
        {
          className: 'opuscapita_day-picker__caption-select',
          onChange: handleYearChange,
          name: 'year',
          value: date.getFullYear(),
          tabIndex: -1
        },
        years.map(function (year, index) {
          return _react2.default.createElement(
            'option',
            { key: index, value: year },
            year
          );
        })
      )
    )
  );
}

var propTypes = _extends({}, _DayPicker2.default.propTypes, {
  className: _propTypes2.default.string,
  dayPickerRef: _propTypes2.default.func,
  hideTodayButton: _propTypes2.default.bool,
  getTodayButtonLabel: _propTypes2.default.func,
  isRange: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  pickerClassName: _propTypes2.default.string
});

var defaultProps = {
  className: '',
  dayPickerRef: function dayPickerRef() {},
  hideTodayButton: false,
  isRange: false,
  labels: _DayPicker2.default.defaultProps.labels,
  getTodayButtonLabel: function getTodayButtonLabel(locale) {
    return (0, _translations2.default)(locale, 'today');
  },
  onChange: function onChange() {},
  pickerClassName: ''
};

var DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.handleDateChange = function (date, captionIndex) {
      if (_this.props.isRange) {
        var range = _this.props.selectedDays[1];
        var fromChanged = captionIndex === 0;
        var toChanged = captionIndex === 1;
        if (fromChanged) {
          _this.props.onChange([date, range.to]);
        }
        if (toChanged) {
          _this.props.onChange([range.from, date]);
        }
      } else {
        _this.props.onChange(date);
      }
    };

    _this.handleMonthChange = function (month) {
      _this.setState({ currentMonth: month });
    };

    _this.handleTodayClick = function () {
      _this.props.onChange(new Date());
    };

    _this.state = {
      date: props.date,
      currentMonth: null
    };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          dayPickerRef = _props.dayPickerRef,
          isRange = _props.isRange,
          hideTodayButton = _props.hideTodayButton,
          onChange = _props.onChange,
          getTodayButtonLabel = _props.getTodayButtonLabel,
          locale = _props.locale,
          pickerClassName = _props.pickerClassName,
          restProps = _objectWithoutProperties(_props, ['className', 'dayPickerRef', 'isRange', 'hideTodayButton', 'onChange', 'getTodayButtonLabel', 'locale', 'pickerClassName']);

      var currentMonth = this.state.currentMonth;


      var splittedProps = splitProps(restProps, Object.keys(_DayPicker2.default.propTypes));
      var commonProps = splittedProps[0];
      var pickerSpecificProps = splittedProps[1];

      var todayButton = hideTodayButton ? null : _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-sm btn-default opuscapita_day-picker__today-button',
          onClick: this.handleTodayClick,
          tabIndex: -1
        },
        getTodayButtonLabel(locale)
      );

      var caption = _react2.default.createElement(Caption, {
        locale: locale,
        onChange: this.handleDateChange,
        isRange: isRange,
        currentMonth: currentMonth
      });

      return _react2.default.createElement(
        'div',
        _extends({ className: 'opuscapita_day-picker ' + className }, commonProps),
        _react2.default.createElement('div', { className: 'opuscapita_day-picker__header' }),
        _react2.default.createElement(
          'div',
          { className: 'opuscapita_day-picker__picker' },
          _react2.default.createElement(_DayPicker2.default, _extends({
            ref: function ref(el) {
              return dayPickerRef(el);
            },
            className: pickerClassName,
            localeUtils: _MomentLocaleUtils2.default,
            locale: locale,
            onDayClick: this.handleDateChange,
            onDayKeyDown: this.handleDateChange,
            onDayTouchEnd: this.handleDateChange,
            onMonthChange: this.handleMonthChange,
            onWeekClick: function onWeekClick() {},
            captionElement: caption,
            tabIndex: -1,
            showWeekNumbers: true
          }, pickerSpecificProps))
        ),
        _react2.default.createElement(
          'div',
          { className: 'opuscapita_day-picker__footer' },
          todayButton
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

exports.default = DayPicker;


DayPicker.propTypes = propTypes;
DayPicker.defaultProps = defaultProps;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;

var _moment = __webpack_require__(16);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// full copy 'react-day-picker/src/addons/MomentLocaleUtils.js'
/* eslint-disable import/no-extraneous-dependencies, no-underscore-dangle */

function formatDay(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _moment2.default)(day).locale(locale).format('ddd ll');
}

function formatMonthTitle(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _moment2.default)(date).locale(locale).format('MMMM YYYY');
}

function formatWeekdayShort(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _moment2.default)().locale(locale)._locale.weekdaysMin()[day];
}

function formatWeekdayLong(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _moment2.default)().locale(locale)._locale.weekdays()[day];
}

function getFirstDayOfWeek() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  var localeData = _moment2.default.localeData(locale);
  return localeData.firstDayOfWeek();
}

function getMonths() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  var months = [];
  var i = 0;
  while (i < 12) {
    months.push((0, _moment2.default)().locale(locale).month(i).format('MMMM'));
    i += 1;
  }
  return months;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(13);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};

var defaultProps = {
  className: '',
  disabled: false,
  onClick: function onClick() {}
};

var InputAddonButton = function (_Component) {
  _inherits(InputAddonButton, _Component);

  function InputAddonButton() {
    _classCallCheck(this, InputAddonButton);

    return _possibleConstructorReturn(this, (InputAddonButton.__proto__ || Object.getPrototypeOf(InputAddonButton)).apply(this, arguments));
  }

  _createClass(InputAddonButton, [{
    key: 'handleOnClick',
    value: function handleOnClick(e) {
      if (!this.props.disabled) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onClick = _props.onClick,
          disabled = _props.disabled,
          restProps = _objectWithoutProperties(_props, ['children', 'className', 'onClick', 'disabled']);

      return _react2.default.createElement(
        'div',
        _extends({
          className: '\n          opuscapita_input-addon-button\n          ' + (disabled ? 'opuscapita_input-addon-button--disabled' : '') + '\n          ' + className,
          onClick: this.handleOnClick.bind(this)
        }, restProps),
        children
      );
    }
  }]);

  return InputAddonButton;
}(_react.Component);

exports.default = InputAddonButton;


InputAddonButton.propTypes = propTypes;
InputAddonButton.defaultProps = defaultProps;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(152);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// returns moment that supports 'no' locale


// localeData call is required becuase og the following bug:
// https://github.com/moment/moment/issues/3883
_moment2.default.localeData('nb');
// define 'nb' locale as fallback/parent for 'no' locale
_moment2.default.defineLocale('no', { parentLocale: 'nb' });

exports.default = _moment2.default;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var isArray = __webpack_require__(51);
var SPECIES = __webpack_require__(0)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(18);
var call = __webpack_require__(86);
var isArrayIter = __webpack_require__(85);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(6);
var getIterFn = __webpack_require__(104);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(19) && !__webpack_require__(20)(function () {
  return Object.defineProperty(__webpack_require__(33)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(14);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(22);
var ITERATOR = __webpack_require__(0)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(91);
var descriptor = __webpack_require__(57);
var setToStringTag = __webpack_require__(35);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(9)(IteratorPrototype, __webpack_require__(0)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(0)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(60).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(14)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(92);
var enumBugKeys = __webpack_require__(48);
var IE_PROTO = __webpack_require__(36)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(33)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(50).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(26);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(56);

module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(21);
var toObject = __webpack_require__(38);
var IE_PROTO = __webpack_require__(36)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(21);
var toIObject = __webpack_require__(27);
var arrayIndexOf = __webpack_require__(46)(false);
var IE_PROTO = __webpack_require__(36)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(5);
var newPromiseCapability = __webpack_require__(55);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(15);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var dP = __webpack_require__(26);
var DESCRIPTORS = __webpack_require__(19);
var SPECIES = __webpack_require__(0)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(17);
var SPECIES = __webpack_require__(0)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(23);
var defined = __webpack_require__(4);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(4);
var fails = __webpack_require__(20);
var spaces = __webpack_require__(102);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(5);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(32);
var ITERATOR = __webpack_require__(0)('iterator');
var Iterators = __webpack_require__(22);
module.exports = __webpack_require__(8).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(24);
var step = __webpack_require__(89);
var Iterators = __webpack_require__(22);
var toIObject = __webpack_require__(27);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(53)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(32);
var test = {};
test[__webpack_require__(0)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(15)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(54);
var global = __webpack_require__(3);
var ctx = __webpack_require__(18);
var classof = __webpack_require__(32);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(5);
var aFunction = __webpack_require__(17);
var anInstance = __webpack_require__(79);
var forOf = __webpack_require__(81);
var speciesConstructor = __webpack_require__(99);
var task = __webpack_require__(60).set;
var microtask = __webpack_require__(90)();
var newPromiseCapabilityModule = __webpack_require__(55);
var perform = __webpack_require__(95);
var promiseResolve = __webpack_require__(96);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(0)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(97)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(35)($Promise, PROMISE);
__webpack_require__(98)(PROMISE);
Wrapper = __webpack_require__(8)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(88)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(25)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(25)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(25)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(25)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(52);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(2)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(2)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(2)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(2)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(59)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(6);
var context = __webpack_require__(37);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(34)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(2)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(2)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(2)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(61);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(37);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(34)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(2)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(2)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(27);
var toLength = __webpack_require__(6);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(100)
});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(2)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(6);
var context = __webpack_require__(37);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(34)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(2)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(2)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(2)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(101)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(49);
var toObject = __webpack_require__(38);
var toLength = __webpack_require__(6);
var aFunction = __webpack_require__(17);
var arraySpeciesCreate = __webpack_require__(47);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(24)('flatMap');


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(49);
var toObject = __webpack_require__(38);
var toLength = __webpack_require__(6);
var toInteger = __webpack_require__(23);
var arraySpeciesCreate = __webpack_require__(47);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(24)('flatten');


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(46)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(24)('includes');


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(105);
var getKeys = __webpack_require__(56);
var redefine = __webpack_require__(15);
var global = __webpack_require__(3);
var hide = __webpack_require__(9);
var Iterators = __webpack_require__(22);
var wks = __webpack_require__(0);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".opuscapita_date-input {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  padding: 0 !important;\n  border: none !important;\n  position: relative !important;\n}\n.opuscapita_date-input__input-container {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.opuscapita_date-input .opuscapita_date-input-field {\n  padding-right: 4ch;\n}\n.opuscapita_date-input-field input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n}\n.opuscapita_date-input-field input:disabled {\n  background: transparent;\n}\n.opuscapita_date-input__picker-container,\n.opuscapita_date-input__variants-container {\n  will-change: opacity, max-height;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n  position: absolute;\n  overflow: hidden;\n  z-index: 900;\n}\n.opuscapita_date-input__variants-container {\n  white-space: nowrap;\n}\n.opuscapita_date-input__variants-btn {\n  border-left: none;\n}\n.opuscapita_date-input__picker-container:focus {\n  outline: none;\n}\n.opuscapita_date-input__reset-btn {\n  position: absolute;\n  top: 0;\n  right: 1ch;\n  z-index: 3;\n}\n", ""]);

// exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".opuscapita_date-input-field {\n  z-index: 1 !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n.opuscapita_date-input-field__input::-ms-clear {\n  display: none !important;\n}\n", ""]);

// exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".opuscapita_date-picker {\n  position: relative;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.opuscapita_date-picker__picker-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n  overflow: hidden;\n  position: absolute;\n  z-index: 999;\n}\n.opuscapita_date-picker__picker-container:focus {\n  outline: none;\n}\n", ""]);

// exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".opuscapita_date-range-input {\n  position: relative !important;\n  display: -webkit-inline-box !important;\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n  padding: 0 !important;\n  border: none !important;\n}\n.opuscapita_date-range-input__picker-container,\n.opuscapita_date-range-input__variants-container {\n  will-change: opacity, max-height;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n  overflow: hidden;\n  position: absolute;\n  z-index: 900;\n}\n.opuscapita_date-range-input__variants-container {\n  white-space: nowrap;\n}\n.opuscapita_date-range-input__picker-container:focus {\n  outline: none;\n}\n.opuscapita_date-range-input__picker-container .DayPicker {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.opuscapita_date-range-input__reset-btn {\n  position: absolute;\n  top: 0;\n  right: 1ch;\n  z-index: 10;\n}\n.opuscapita_date-range-input__input-field {\n  width: 100% !important;\n  height: 100% !important;\n  border: none !important;\n  text-align: center;\n  box-shadow: none !important;\n}\n.opuscapita_date-range-input__left-input-field {\n  padding-right: 24px;\n}\n.opuscapita_date-range-input__left-input-field input {\n  text-align: left;\n}\n.opuscapita_date-range-input__right-input-field {\n  padding-right: 36px;\n}\n.opuscapita_date-range-input__right-input-field input {\n  text-align: right;\n}\n.opuscapita_date-range-input__input-field[placeholder] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.opuscapita_date-range-input__input-field-container {\n  position: relative !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-flex: 1 !important;\n      -ms-flex: 1 !important;\n          flex: 1 !important;\n  padding: 0 !important;\n}\n.opuscapita_date-range-input__input-field-container--focused {\n  border-color: #369 !important;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(51, 102, 153, 0.6) !important;\n}\n.opuscapita_date-range-input__input-field-container.has-error {\n  border-color: #a94442 !important;\n}\n.opuscapita_date-range-input__input-field-container--focused.has-error {\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483 !important;\n}\n.opuscapita_date-range-input__variants-btn {\n  border-left: none;\n}\n.opuscapita_date-range-input__humanized-duration {\n  position: absolute;\n  left: 0;\n  font-size: 0.8em;\n  opacity: 0.6;\n  bottom: -2px;\n  -webkit-transform: translate(0, 100%);\n          transform: translate(0, 100%);\n}\n.opuscapita_date-range-input__dash {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  z-index: 10;\n  pointer-events: none;\n  color: #aaa;\n  padding-right: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".opuscapita_date-range-variants__list {\n  list-style: none;\n  padding: 0;\n}\n", ""]);

// exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".opuscapita_day-picker {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.opuscapita_day-picker__picker {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.opuscapita_day-picker__picker abbr {\n  border-bottom: none;\n  cursor: default;\n  text-decoration: none;\n}\n.opuscapita_day-picker__picker .DayPicker {\n  padding-top: 0;\n}\n.opuscapita_day-picker,\n.opuscapita_day-picker__picker:focus,\n.opuscapita_day-picker__picker .DayPicker,\n.opuscapita_day-picker__picker .DayPicker-Day:focus {\n  outline: none;\n}\n.opuscapita_day-picker__picker .DayPicker-Day {\n  border: none;\n  position: relative;\n  transition: -webkit-transform 0.1s ease;\n  transition: transform 0.1s ease;\n  transition: transform 0.1s ease, -webkit-transform 0.1s ease;\n}\n.opuscapita_day-picker__picker .DayPicker-Day:active:focus {\n  z-index: 10;\n  -webkit-transform: scale(1.4);\n          transform: scale(1.4);\n}\n.opuscapita_day-picker__picker .DayPicker-Day:focus {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.opuscapita_day-picker__picker .DayPicker-wrapper {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.opuscapita_day-picker__picker .DayPicker-wrapper:focus {\n  outline: none;\n}\n.opuscapita_day-picker__picker .DayPicker-WeekNumber:hover {\n  cursor: default;\n}\n.opuscapita_day-picker__picker .DayPicker-WeekNumber:focus {\n  outline: none;\n}\n.opuscapita_day-picker__picker .DayPicker-Day:not(.DayPicker-Day--outside):hover:after {\n  background: #000;\n  bottom: 0;\n  content: '';\n  left: 0;\n  opacity: 0.075;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.opuscapita_day-picker__picker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n  background-color: #EC6608;\n}\n.opuscapita_day-picker__picker .DayPicker-Day--today {\n  font-weight: 600;\n  color: #000;\n}\n.opuscapita_day-picker__picker .DayPicker-NavBar {\n  z-index: 9999;\n}\n.opuscapita_day-picker__picker .DayPicker-NavButton:focus {\n  outline: none;\n}\n.opuscapita_day-picker__footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.opuscapita_day-picker__today-button {\n  border-left: none;\n  border-right: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.opuscapita_day-picker__caption {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 1.6em;\n  position: relative;\n  top: -2px;\n}\n.opuscapita_day-picker__caption-select {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: transparent;\n  border: none;\n  position: relative;\n  padding: 0 8px;\n}\n.opuscapita_day-picker__caption-select::-ms-expand {\n  display: none;\n}\n.opuscapita_day-picker__caption-select:hover {\n  cursor: pointer;\n}\n.opuscapita_day-picker__caption-select:focus {\n  outline: none;\n}\n", ""]);

// exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".opuscapita_input-addon-button {\n  border-left: none;\n  color: #aaa;\n  width: 3ch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n}\n.opuscapita_input-addon-button:focus {\n  outline: none;\n}\n.opuscapita_input-addon-button:hover:not(.opuscapita_input-addon-button--disabled) {\n  color: #666;\n  cursor: pointer;\n}\n.opuscapita_input-addon-button--disabled {\n  cursor: not-allowed;\n}\n", ""]);

// exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(137);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateInput.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateInput.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(138);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateInputField.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateInputField.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(139);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DatePicker.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DatePicker.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(140);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateRangeInput.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateRangeInput.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(141);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateVariants.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DateVariants.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(142);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DayPicker.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./DayPicker.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(143);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./InputAddonButton.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js??ref--3-2!../../../../node_modules/less-loader/index.js??ref--3-3!./InputAddonButton.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = require("@opuscapita/react-autocompletes");

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = require("react-day-picker/lib/src/DayPicker");

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = require("react-day-picker/lib/style.css");

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(65);
__webpack_require__(64);
__webpack_require__(66);
module.exports = __webpack_require__(63);


/***/ })
/******/ ]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@opuscapita/react-dates/lib/index.js
// module id = 412
// module chunks = 0